import { GroupDTO } from "./../../model/user";
import router from "@/sites/admin/router";
import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import { ROLES } from "@/model/user";
import { AuthService } from "@/common/api/services/AuthService";
import { ADMIN_ROLE, ADMIN_GROUP_ROLE } from "@/common/constant";

@Module({ namespaced: true })
export default class AuthModule extends VuexModule {
  token = localStorage.getItem("token") || "";
  expiredAt = "";
  role = "";
  userLogging: any;
  usingGroup = "";
  groupUsers = [];
  refreshToken = "";

  get getGroupUsers(): any {
    return this.groupUsers;
  }

  get getUsingGroup(): string {
    return this.usingGroup;
  }

  get getUsingGroupName(): string {
    return this.groupUsers
      ? this.groupUsers.find((item) => item.id == this.usingGroup).name
      : "";
  }

  get getLoggingUser(): string {
    return this.userLogging;
  }

  get isAdmin(): boolean {
    return this.userLogging && this.userLogging.role == ADMIN_ROLE;
  }

  get isGroupAdmin(): boolean {
    return this.userLogging && this.userLogging.role == ADMIN_GROUP_ROLE;
  }

  get isPrivateUsingGroup(): boolean {
    const group = this.groupUsers.find(
      (item) => item.id.toString() == this.usingGroup
    );
    return this.isGroupAdmin && group && group.requestApproved;
  }

  get isExistUsingGroup(): boolean {
    const group = this.groupUsers.find(
      (item) => item.id.toString() == this.usingGroup
    );
    return this.isGroupAdmin && group;
  }

  @Mutation
  setToken(token: string): void {
    this.token = token;
    localStorage.setItem("token", token);
  }
  @Mutation
  setRefreshToken(refreshToken: string): void {
    this.refreshToken = refreshToken;
    localStorage.setItem("refresh_token", refreshToken);
  }
  @Mutation
  setExpiredAt(time: string): void {
    this.expiredAt = time;
  }
  @Mutation
  setRole(role: string): void {
    this.role = role;
  }
  @Mutation
  setUserLogging(user): void {
    this.userLogging = user;
  }

  @Mutation
  setGroupUser(groups: GroupDTO[]): void {
    this.groupUsers = groups;
  }

  @Mutation
  setUsingGroup(id: string): void {
    localStorage.setItem("using_group", id);
    this.usingGroup = id;
    console.log("Using group id", id);
  }

  @Action({ rawError: true })
  updateToken(token: string): void {
    this.context.commit("setToken", token);
  }
  @Action({ rawError: true })
  updateRefreshToken(refreshToken: string): void {
    this.context.commit("setRefreshToken", refreshToken);
  }
  @Action
  updateExpiredAt(time: string): void {
    this.context.commit("setExpiredAt", time);
  }
  @Action
  updateRole(role: string): void {
    this.context.commit("setRole", role);
  }

  @Action
  setUser(user) {
    this.context.commit("setUserLogging", user);
  }

  @Action
  updateGroupUsers(groups: GroupDTO[]) {
    this.context.commit("setGroupUsers", groups);
  }

  @Action
  updateUsingGroup(id) {
    this.context.commit("setUsingGroup", id);
  }

  @Action
  async fetchCurrentUser(): Promise<void> {
    try {
      const response = await AuthService.authMe({
        disabledLoadinng: true,
      });

      this.context.commit("setUserLogging", response.data.user);
      this.context.commit("setRole", response.data.user.role);
      if (response.data.user.role == ROLES.GROUP_ADMIN) {
        this.context.commit("setGroupUser", response.data.user.groups);
        if (
          !this.getUsingGroup ||
          (this.getUsingGroup && !this.isExistUsingGroup)
        ) {
          this.context.commit("setUsingGroup", response.data.user.groups[0].id);
        }

        if (!response.data.user.groups) {
          this.logout();
        }
      }
    } catch (error) {
      if (error.status !== 401) {
        this.context.commit("setToken", "");
        this.context.commit("setRefreshToken", "");
        this.context.commit("setExpiredAt", "");
        this.context.commit("setUserLogging", null);
        this.context.commit("setGroupUser", "");
        this.context.commit("setUsingGroup", "");
        router.push({ name: "login" });
      }
    }
  }

  @Action
  logout(redirect = true): void {
    this.context.commit("setToken", "");
    this.context.commit("setRefreshToken", "");
    this.context.commit("setExpiredAt", "");
    this.context.commit("setUserLogging", null);
    this.context.commit("setGroupUser", "");
    this.context.commit("setUsingGroup", "");
    redirect && router.push({ name: "login" });
  }
}

// export default getModule(AuthModule);
